import type { FC } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  BookOpen,
  Trophy,
  User,
  Users,
  Award,
  Shield,
  Bot,
  ClipboardCheck,
} from 'lucide-react';
import WebApp from '@twa-dev/sdk';
import { useAppStore } from '../store/useAppStore';
import { Flame, Coins } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { t } from '../i18n';

/**
 * Pastki navigatsiya.
 *
 * Ilgari ustoz rejimi uchun binafsha ranglar inline yozilgan edi — bu
 * dizayn tizimidan chetga chiqardi va light mode'da o'qilmasdi. Endi ikkala
 * rol ham bir xil tokenlardan foydalanadi; farq faqat belgilar va matnda.
 */
export const Navbar: FC = () => {
  const { role } = useAppStore();
  const isTeacher = role === 'teacher';

  const tap = () => {
    try {
      WebApp.HapticFeedback.impactOccurred('light');
    } catch {
      // Telegramdan tashqarida
    }
  };

  const cls = ({ isActive }: { isActive: boolean }) =>
    `nav-item${isActive ? ' is-active' : ''}`;

  // `/exam/:id` va natija sahifasi ham shu boʻlimga tegishli.
  const { pathname } = useLocation();
  const examCls = ({ isActive }: { isActive: boolean }) =>
    cls({ isActive: isActive || pathname.startsWith('/exam/') });

  const { studentName, coins, streak, centerName, coinsEnabled } =
    useAppStore();
  const initials = (studentName || '?')
    .split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <nav className="nav" aria-label={t('Asosiy menyu')}>
      {/*
        FAQAT KOMPYUTERDA koʻrinadi (`.nav-lg`).

        Telefonda bu maʼlumot yuqoridagi `.topbar` da turadi. Kompyuterda
        esa yon panel bor — oʻsha maʼlumotni ikkinchi marta yuqorida
        koʻrsatish takrorlash boʻlardi, shuning uchun u BU YERGA
        koʻchiriladi va `.topbar` yashiriladi.
      */}
      <div className="nav-lg nav-brand">Shaftoli</div>

      <div className="nav-lg nav-user">
        <div className="avatar" aria-hidden="true">
          {initials}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="nav-user-name">{studentName}</div>
          <div className="nav-user-sub">{centerName || 'Shaftoli'}</div>
        </div>
      </div>
      <NavLink to="/" onClick={tap} className={cls} end>
        {isTeacher ? <Users size={19} /> : <BookOpen size={19} />}
        <span>{t(isTeacher ? 'Guruhlar' : 'Darslar')}</span>
      </NavLink>

      <NavLink to="/leaderboard" onClick={tap} className={cls}>
        {isTeacher ? <Award size={19} /> : <Trophy size={19} />}
        <span>{t(isTeacher ? 'Natijalar' : 'Reyting')}</span>
      </NavLink>

      {/* Ustozga emas: roʻyxat API ustoz rejimida boʻsh qaytaradi,
          imtihonlar esa boshqaruv panelida yaratiladi. */}
      {!isTeacher && (
        <NavLink to="/exams" onClick={tap} className={examCls}>
          <ClipboardCheck size={19} />
          <span>{t('Imtihon')}</span>
        </NavLink>
      )}

      {!isTeacher && (
        <NavLink to="/chat" onClick={tap} className={cls}>
          <Bot size={19} />
          <span>{t('Yordam')}</span>
        </NavLink>
      )}

      <NavLink to="/profile" onClick={tap} className={cls}>
        {isTeacher ? <Shield size={19} /> : <User size={19} />}
        <span>{t('Profil')}</span>
      </NavLink>

      {/* Yon panel etagi — koʻrsatkichlar va mavzu tugmasi. */}
      <div className="nav-lg nav-footer">
        {!isTeacher && (
          <div className="nav-stats">
            <span className="chip">
              <Flame size={12} aria-hidden="true" />
              {streak}
            </span>
            {coinsEnabled && (
              <span className="chip">
                <Coins size={12} aria-hidden="true" />
                {coins}
              </span>
            )}
          </div>
        )}
        <ThemeToggle />
      </div>
    </nav>
  );
};
